import React, { FC } from 'react';
import { useTranslate } from '@im/react-localization';
import TextField from '@mui/material/TextField';
import { FormCtrl } from 'src/components/Form';
import LabeledField from 'src/components/Form/LabeledField';
import { CustomerGroup } from '../hooks/customerGroupSearchQuery';

export const GetBasicFieldValidations = () => {
  const translate = useTranslate();
  return {
    description: (value: any) =>
      !value && translate('CustomerGroups.validationRequired'),
    name: (value: any) =>
      !value && translate('CustomerGroups.validationRequired'),
  };
};

type BasicForm = Pick<FormCtrl<Partial<CustomerGroup>>, 'getInputProps'>;

const DescriptionField: FC<BasicForm> = ({ getInputProps }) => {
  const translate = useTranslate();
  return (
    <LabeledField isRequired label={translate('CustomerGroups.description')}>
      <TextField
        aria-describedby={translate('CustomerGroups.description')}
        margin="normal"
        maxRows={10}
        minRows={5}
        multiline
        {...getInputProps('description')}
        placeholder={translate('CustomerGroups.descriptionPlaceholder')}
        sx={{
          margin: '0px',
        }}
      />
    </LabeledField>
  );
};
export { DescriptionField };

const CustomerGroupBasicFields: FC<BasicForm> = ({ getInputProps }) => {
  const translate = useTranslate();
  return (
    <>
      <LabeledField isRequired label={translate('CustomerGroups.name')}>
        <TextField
          aria-describedby={translate('CustomerGroups.name')}
          margin="normal"
          {...getInputProps('name')}
          placeholder={translate('CustomerGroups.namePlaceholder')}
          sx={{
            margin: '0px',
          }}
        />
      </LabeledField>
      <DescriptionField {...{ getInputProps }} />
    </>
  );
};
export default CustomerGroupBasicFields;
